import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Button, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { addAlert } from '../../actions/alerts.action';
import { useMutation } from 'react-query';
import { updateObjectiveRateLock } from '../../api/objective/objectiveRate.api';

export const EvaluationStatusDialog = (
  {
    objective,
    evaluationStatusDialogOpen,
    setEvaluationStatusDialogOpen,
    isEvaluationClosed,
    appraiserId,
    onSubmitSuccess
  }
) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const updateObjectiveRateLockMutation = useMutation(
    async () => updateObjectiveRateLock({
      objective: {
        ...objective,
        isEvaluationClosed,
        appraiserId
      }
    }),
    {
      onSuccess: () => {
        onSubmitSuccess();
        setEvaluationStatusDialogOpen(false);
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  return (
    <Dialog
      open={ evaluationStatusDialogOpen }
      onClose={ () => setEvaluationStatusDialogOpen(false) }
    >
      <DialogTitle>{t('objective.evaluation.status.dialog.lock.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('objective.evaluation.status.dialog.lock.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={ updateObjectiveRateLockMutation.mutate }
          color="primary"
          variant="contained"
        >
          {t('objective.evaluation.status.dialog.lock.confirm')}
        </Button>
        <Button onClick={ () => setEvaluationStatusDialogOpen(false) } color="primary" autoFocus>
          {t('objective.evaluation.status.dialog.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
